import { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { Desktop } from '../../App';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';
import { AKASHA } from '../../routes/routes';
import { color, colors } from '../../styles/GlobalStyles';
import { getDashboardInfo } from './Dashboard.actions';

import {
  Box,
  Flexed,
  SectionSeparator,
  UserImageCircle
} from '../../styles/GlobalComponents';
import { EarningsComponent2 } from './EarningsComponent2';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

// import required modules
import {
  InviteLinks,
  InviteLinksUnderlay,
  ReferralLink,
  SlideWrapper,
  TopPerformerOverlay
} from './DashboardStyled';

import Modal from 'react-modal';
import mex from '../../assets/images/backoffice/unitedOne/mex.png';
import newStrategiesBanner from '../../assets/images/backoffice/unitedOne/newStrategiesBanner.png';
import calendarPlaceholder from '../../assets/images/calendarPlaceholder.png';
import unitedOneBanner from '../../assets/images/backoffice/unitedOne/unitedOneBanner.png';
import { H1, H2, H3, H4, H5, P2, P3 } from '../../styles/FontStyles';
import { User } from '../../types/loginTypes';
import MigrationTermsPrivacy from '../MigrationTermsPrivacy/MigrationTermsPrivacy';

import {
  copyLink,
  PERSONAL_LINK,
  PLATFORM_LINK
} from '../../helpers/helperFunctions';
import inviteLinksUnderlay from '../../assets/images/referralBack.png';
import { Calendar } from './Calendar';
import { getCurrentLicense } from '../../slices/auth-slice';
import { SuccessToast } from '../../components';

const Dashboard = () => {
  const dispatch = useAppDispatch();
  // const { t } = useTranslation('dashboard');
  const { userInfo } = useAppSelector((state) => state.auth);
  const [termsConditionsModal, setTermsConditionsModal] = useState(false);
  const { dashboardInfo, loading } = useAppSelector((state) => state.dashboard);

  const user = userInfo.user;

  const history = useHistory();

  useEffect(() => {
    if (!userInfo.isSideModalChecked) {
      dispatch(getCurrentLicense());
      setTermsConditionsModal(true);
    }
    dispatch(getDashboardInfo());
  }, [dispatch, userInfo.isSideModalChecked]);

  const referralUrl = `${PLATFORM_LINK}/ambassador/${userInfo?.user?.referralCode}/${userInfo?.user?.id}`;

  if (loading && !dashboardInfo) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'dashboardInfo'}>
      <Flexed gap='20px' rowSM>
        <Flexed width='30%' widthSM='100%'>
          <div style={{ width: '100%' }}>
            <EarningsComponent2 user={user} backOffice={dashboardInfo} />
          </div>
        </Flexed>
        <Flexed column width='70%' widthSM='100%' gap='20px'>
          <Desktop>
            <Flexed>
              <img
                src={unitedOneBanner}
                alt='flipMeBanner'
                onClick={() => history.push(AKASHA)}
                style={{ width: '100%', marginBottom: 0 }}
              />
            </Flexed>
          </Desktop>
          <Flexed gap='20px' rowSM>
            <Box
              width='50%'
              widthSM='100%'
              relative
              overflow='hidden'
              m='0'
              style={{ marginBottom: 0 }}>
              <TopPerformerOverlay>
                <H3
                  center
                  color={color.colors.primary900}
                  style={{ fontSize: '35px', lineHeight: '50px' }}>
                  Unlocking <br /> Soon
                </H3>
              </TopPerformerOverlay>
              <H3 mb='15' color={color.colors.primary900}>
                Top Performer
              </H3>
              <TopPerformer user={user} title='Weekly by Volume' />
              <TopPerformer user={user} title='Monthly by Volume' />
              <TopPerformer user={user} title='Top sign ups' />
            </Box>
            <Box
              relative
              width='50%'
              widthSM='100%'
              overflow='hidden'
              m='0'
              style={{ marginBottom: 0 }}
              p='40px 50px'
              pSM='30px'>
              <InviteLinks>
                <Flexed gap='10px'>
                  <UserImageCircle
                    image={userInfo?.user?.profileImageUrl}
                    name={userInfo?.user?.name}
                    surname={userInfo?.user?.surname}
                    size='40px'
                    fontSize='16px'
                    color={color.colors.neutral0}
                    fontColor={color.colors.primary900}
                    // margin={wide ? '0 16px 0 0' : '0'}
                  />
                  <div>
                    <P2 bold color={color.colors.neutral0}>
                      {userInfo?.user?.name}
                    </P2>
                    <P3 color={color.colors.neutral0}>
                      ID: {userInfo?.user?.id}
                    </P3>
                  </div>
                </Flexed>
                <Flexed gap='10px'>
                  <svg
                    width='21'
                    height='21'
                    viewBox='0 0 21 21'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <g clipPath='url(#clip0_24831_23433)'>
                      <path
                        d='M4.93771 7.87235L5.01897 7.89292C4.88683 8.8747 4.89668 9.86306 5.0715 10.8399C5.11254 11.0679 5.31116 11.6069 5.25617 11.7888L3.36267 13.7935C1.52499 16.4755 4.79818 19.5409 7.33516 17.4893C8.51952 16.1619 9.94272 15.0081 11.0828 13.6445C12.1399 12.3805 12.405 10.793 11.0622 9.5989C10.8932 9.4483 10.4138 9.23104 10.4286 9.00473C10.4417 8.81133 10.9383 8.11101 11.0852 7.93407C11.2174 7.77524 11.8822 7.09055 12.0283 7.03047C12.2794 6.92761 12.6143 7.23292 12.8055 7.39833C15.3458 9.58655 15.432 13.1466 13.2766 15.6385C12.2031 16.8803 10.651 18.5048 9.42564 19.5837C6.33219 22.3085 1.39941 20.9186 0.255271 16.9429C-0.947145 12.7656 2.38679 10.6021 4.87862 7.99497C4.91227 7.96041 4.93279 7.91926 4.93853 7.87153L4.93771 7.87235Z'
                        fill='#FAFAFA'
                      />
                      <path
                        d='M15.9589 13.1729C16.0976 12.2611 16.1321 11.3666 15.9876 10.4523C15.9507 10.2161 15.6946 9.38326 15.7192 9.25817C15.7324 9.19234 15.7767 9.15366 15.8136 9.10346C16.4555 8.24265 17.6382 7.58759 18.0075 6.49553C18.9333 3.75841 15.661 1.62779 13.5188 3.63743C12.4058 4.68175 11.1025 6.03551 10.0773 7.172C8.93812 8.4344 8.49983 10.0038 9.8508 11.3452C10.0002 11.4933 10.4081 11.7089 10.491 11.8126C10.5427 11.8776 10.5583 11.9146 10.5534 12.0002C10.5443 12.1558 10.024 12.8257 9.89266 12.9861C9.74657 13.1639 9.0046 14.0198 8.84619 14.0354C8.71159 14.0486 8.29218 13.7079 8.17234 13.6042C5.76013 11.5213 5.56314 7.79003 7.66019 5.4043C8.60571 4.32953 9.77529 3.24159 10.7963 2.22114C11.7336 1.28462 12.3574 0.630379 13.6961 0.238656C18.0264 -1.02786 21.9825 2.90995 20.7825 7.26334C20.4649 8.4163 19.8493 9.19892 19.0532 10.0498C18.0543 11.1172 16.975 12.1212 15.9589 13.1721V13.1729Z'
                        fill='#FAFAFA'
                      />
                    </g>
                    <defs>
                      <clipPath id='clip0_24831_23433'>
                        <rect width='21' height='21' fill='white' />
                      </clipPath>
                    </defs>
                  </svg>

                  <P2 semiBold color={color.colors.neutral0}>
                    Invite Links
                  </P2>
                </Flexed>
              </InviteLinks>

              <Flexed
                pointer
                mt='40'
                mtSM='20'
                mb='10'
                gap='20px'
                onClick={() => {
                  copyLink(referralUrl, 'Referral link has been copied');
                }}>
                <P2 semiBold>Referral link to Backoffice</P2>
                <svg
                  width='19'
                  height='19'
                  viewBox='0 0 19 19'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'>
                  <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M11.875 0.990235H8.66367C7.20878 0.990222 6.0564 0.990212 5.15452 1.11147C4.22636 1.23626 3.47511 1.49918 2.88265 2.09164C2.2902 2.68409 2.02727 3.43534 1.90248 4.36351C1.78123 5.26538 1.78124 6.41776 1.78125 7.87265V12.6673C1.78125 14.1495 2.86746 15.378 4.28728 15.6002C4.39651 16.2051 4.60554 16.7213 5.02578 17.1415C5.5023 17.6181 6.10228 17.823 6.81486 17.9188C7.50121 18.0111 8.37388 18.0111 9.45656 18.0111H11.9184C13.0011 18.0111 13.8738 18.0111 14.5601 17.9188C15.2727 17.823 15.8727 17.6181 16.3492 17.1415C16.8257 16.665 17.0307 16.065 17.1265 15.3525C17.2188 14.6661 17.2188 13.7934 17.2188 12.7108V8.66555C17.2188 7.58287 17.2188 6.7102 17.1265 6.02385C17.0307 5.31126 16.8257 4.71128 16.3492 4.23476C15.929 3.81453 15.4127 3.60549 14.8079 3.49627C14.5857 2.07644 13.3572 0.990235 11.875 0.990235ZM13.5607 3.38199C13.321 2.68142 12.6568 2.17774 11.875 2.17774H8.70833C7.19877 2.17774 6.12632 2.179 5.31276 2.28838C4.51627 2.39546 4.05738 2.59628 3.72234 2.93132C3.3873 3.26637 3.18648 3.72525 3.07939 4.52174C2.97001 5.33531 2.96875 6.40775 2.96875 7.91732V12.6673C2.96875 13.4491 3.47244 14.1133 4.17301 14.353C4.15623 13.8702 4.15624 13.3242 4.15625 12.7108V8.66554C4.15623 7.58287 4.15622 6.7102 4.2485 6.02385C4.3443 5.31126 4.54926 4.71128 5.02578 4.23476C5.5023 3.75824 6.10228 3.55329 6.81486 3.45748C7.50121 3.36521 8.37388 3.36522 9.45656 3.36523H11.9184C12.5318 3.36523 13.0778 3.36522 13.5607 3.38199ZM5.86547 5.07445C6.08457 4.85535 6.39219 4.71249 6.9731 4.63439C7.57108 4.554 8.36363 4.55274 9.5 4.55274H11.875C13.0114 4.55274 13.8039 4.554 14.4019 4.63439C14.9828 4.71249 15.2904 4.85535 15.5095 5.07445C15.7286 5.29356 15.8715 5.60117 15.9496 6.18208C16.03 6.78007 16.0312 7.57261 16.0312 8.70898V12.6673C16.0312 13.8037 16.03 14.5962 15.9496 15.1942C15.8715 15.7751 15.7286 16.0827 15.5095 16.3019C15.2904 16.521 14.9828 16.6638 14.4019 16.7419C13.8039 16.8223 13.0114 16.8236 11.875 16.8236H9.5C8.36363 16.8236 7.57108 16.8223 6.9731 16.7419C6.39219 16.6638 6.08457 16.521 5.86547 16.3019C5.64636 16.0827 5.50351 15.7751 5.42541 15.1942C5.34501 14.5962 5.34375 13.8037 5.34375 12.6673V8.70898C5.34375 7.57261 5.34501 6.78007 5.42541 6.18208C5.50351 5.60117 5.64636 5.29356 5.86547 5.07445Z'
                    fill='#373737'
                  />
                </svg>
              </Flexed>

              <ReferralLink>{referralUrl}</ReferralLink>

              <Flexed mt='40' mtSM='20' mb='10' gap='20px'>
                <P2 semiBold>Social Media</P2>
              </Flexed>

              <Flexed gap='10px' mb='70'>
                <a
                  href='https://www.facebook.com/UnitedOne.Global'
                  target='_blank'
                  rel='noreferrer'>
                  <svg
                    width='30'
                    height='30'
                    viewBox='0 0 30 30'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <g clipPath='url(#clip0_24831_23490)'>
                      <path
                        d='M29.4582 14.7291C29.4582 6.59444 22.8638 0 14.7291 0C6.59444 0 0 6.59444 0 14.7291C0 22.0808 5.38622 28.1743 12.4277 29.2792V18.9867H8.68787V14.7291H12.4277V11.4841C12.4277 7.79261 14.6266 5.75355 17.9911 5.75355C19.6026 5.75355 21.2882 6.04123 21.2882 6.04123V9.66597H19.4308C17.6011 9.66597 17.0305 10.8013 17.0305 11.9662V14.7291H21.1155L20.4625 18.9867H17.0305V29.2792C24.072 28.1743 29.4582 22.0808 29.4582 14.7291Z'
                        fill='#1877F2'
                      />
                      <path
                        d='M20.4621 18.9871L21.1152 14.7295H17.0302V11.9665C17.0302 10.8017 17.6008 9.66632 19.4305 9.66632H21.2878V6.04158C21.2878 6.04158 19.6022 5.75391 17.9907 5.75391C14.6263 5.75391 12.4273 7.79296 12.4273 11.4844V14.7295H8.6875V18.9871H12.4273V29.2796C13.9523 29.5182 15.5052 29.5182 17.0302 29.2796V18.9871H20.4621Z'
                        fill='white'
                      />
                    </g>
                    <defs>
                      <clipPath id='clip0_24831_23490'>
                        <rect width='29.4582' height='29.4582' fill='white' />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
                <a
                  href='https://www.instagram.com/unitedone.global'
                  target='_blank'
                  rel='noreferrer'>
                  <svg
                    width='30'
                    height='30'
                    viewBox='0 0 30 30'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <g clipPath='url(#clip0_24831_23493)'>
                      <mask
                        id='mask0_24831_23493'
                        style={{ maskType: 'luminance' }}
                        maskUnits='userSpaceOnUse'
                        x='0'
                        y='0'
                        width='30'
                        height='30'>
                        <path
                          d='M14.7291 29.4582C22.8638 29.4582 29.4582 22.8638 29.4582 14.7291C29.4582 6.59444 22.8638 0 14.7291 0C6.59444 0 0 6.59444 0 14.7291C0 22.8638 6.59444 29.4582 14.7291 29.4582Z'
                          fill='white'
                        />
                      </mask>
                      <g mask='url(#mask0_24831_23493)'>
                        <path
                          d='M6.32814 59.6075C23.8049 59.6075 37.9727 45.4397 37.9727 27.9629C37.9727 10.4861 23.8049 -3.68164 6.32814 -3.68164C-11.1487 -3.68164 -25.3164 10.4861 -25.3164 27.9629C-25.3164 45.4397 -11.1487 59.6075 6.32814 59.6075Z'
                          fill='url(#paint0_radial_24831_23493)'
                        />
                      </g>
                      <path
                        d='M18.8714 11.737C19.5069 11.737 20.0221 11.2218 20.0221 10.5863C20.0221 9.95074 19.5069 9.43555 18.8714 9.43555C18.2359 9.43555 17.7207 9.95074 17.7207 10.5863C17.7207 11.2218 18.2359 11.737 18.8714 11.737Z'
                        fill='white'
                      />
                      <path
                        d='M14.7292 11.0469C14.0009 11.0469 13.2889 11.2628 12.6834 11.6675C12.0778 12.0721 11.6059 12.6472 11.3272 13.32C11.0485 13.9929 10.9755 14.7332 11.1176 15.4475C11.2597 16.1618 11.6104 16.8179 12.1254 17.3329C12.6404 17.8479 13.2965 18.1986 14.0108 18.3407C14.7251 18.4828 15.4654 18.4098 16.1383 18.1311C16.8111 17.8524 17.3862 17.3805 17.7909 16.7749C18.1955 16.1694 18.4114 15.4574 18.4114 14.7292C18.4114 13.7526 18.0235 12.8159 17.3329 12.1254C16.6424 11.4348 15.7058 11.0469 14.7292 11.0469ZM14.7292 16.5703C14.365 16.5703 14.009 16.4623 13.7063 16.26C13.4035 16.0577 13.1675 15.7701 13.0282 15.4337C12.8888 15.0973 12.8524 14.7271 12.9234 14.37C12.9944 14.0128 13.1698 13.6848 13.4273 13.4273C13.6848 13.1698 14.0128 12.9944 14.37 12.9234C14.7271 12.8523 15.0973 12.8888 15.4337 13.0282C15.7701 13.1675 16.0577 13.4035 16.26 13.7063C16.4623 14.009 16.5703 14.365 16.5703 14.7292C16.5703 15.2175 16.3763 15.6858 16.031 16.031C15.6858 16.3763 15.2175 16.5703 14.7292 16.5703Z'
                        fill='white'
                      />
                      <path
                        d='M19.3326 7.36523H10.1269C8.60169 7.36523 7.36523 8.60169 7.36523 10.1269V19.3326C7.36523 20.8579 8.60169 22.0943 10.1269 22.0943H19.3326C20.8579 22.0943 22.0943 20.8579 22.0943 19.3326V10.1269C22.0943 8.60169 20.8579 7.36523 19.3326 7.36523Z'
                        stroke='white'
                        strokeWidth='1.46376'
                        strokeMiterlimit='10'
                      />
                    </g>
                    <defs>
                      <radialGradient
                        id='paint0_radial_24831_23493'
                        cx='0'
                        cy='0'
                        r='1'
                        gradientUnits='userSpaceOnUse'
                        gradientTransform='translate(6.32814 27.9629) scale(31.6446)'>
                        <stop stopColor='#FFD676' />
                        <stop offset='0.25' stopColor='#F2A454' />
                        <stop offset='0.38' stopColor='#F05C3C' />
                        <stop offset='0.7' stopColor='#C22F86' />
                        <stop offset='0.96' stopColor='#6666AD' />
                        <stop offset='0.99' stopColor='#5C6CB2' />
                      </radialGradient>
                      <clipPath id='clip0_24831_23493'>
                        <rect width='29.4582' height='29.4582' fill='white' />
                      </clipPath>
                    </defs>
                  </svg>
                </a>
                <a
                  href='https://x.com/united_one48151'
                  target='_blank'
                  rel='noreferrer'>
                  <svg
                    width='29'
                    height='29'
                    viewBox='0 0 29 29'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M28.7263 14.3632C28.7263 14.7512 28.7114 15.1317 28.6741 15.5122C28.398 19.0041 26.8535 22.1603 24.5106 24.5106C21.9066 27.1147 18.3177 28.7263 14.3632 28.7263C13.2962 28.7263 12.2591 28.6069 11.2667 28.3831C10.5653 28.2339 9.89379 28.0324 9.23719 27.7787C3.85007 25.7045 0 20.4591 0 14.3632C0 10.4161 1.61912 6.8197 4.21568 4.21568C6.8197 1.61166 10.4086 0 14.3632 0C18.3177 0 21.9066 1.61166 24.5106 4.21568C26.1372 5.84972 27.3833 7.87176 28.0846 10.1251C28.3906 11.1175 28.592 12.1471 28.6741 13.2141C28.6816 13.2887 28.689 13.3708 28.689 13.4454C28.7189 13.7513 28.7263 14.0498 28.7263 14.3632Z'
                      fill='url(#paint0_linear_24831_23527)'
                    />
                    <path
                      d='M28.7259 14.3626C28.7259 14.7506 28.711 15.1312 28.6737 15.5117C28.3976 19.0036 26.8531 22.1598 24.5102 24.5101C21.9062 27.1141 18.3173 28.7258 14.3628 28.7258C13.2958 28.7258 12.2587 28.6064 11.2663 28.3826L6.05078 22.9208L12.4601 15.4818L6.14778 6.29688H11.617L16.3027 11.0125L20.3543 6.29688H22.6225L28.4499 12.5346C28.5394 12.833 28.6215 13.139 28.6886 13.4449C28.7185 13.7508 28.7259 14.0493 28.7259 14.3626Z'
                      fill='#161616'
                    />
                    <path
                      d='M23.0407 22.9212H17.5715L13.4677 16.9446L8.32685 22.9212H6.05859L12.4605 15.4822L6.15559 6.30469H11.6248L15.5047 11.953L20.3621 6.30469H22.6303L16.512 13.4154L23.0482 22.9212H23.0407ZM17.9297 22.2422H21.7573L15.6539 13.3632L21.153 6.96875H20.668L15.4376 13.0498L11.2592 6.96875H7.43149L13.3111 15.5195L7.52849 22.2422H8.01348L13.5274 15.8329L17.9297 22.2422ZM21.1604 21.9288H18.2206L8.01348 7.33436H10.9533L21.1604 21.9288ZM18.5713 21.2573H19.8622L10.6026 8.01334H9.31176L18.5713 21.2573Z'
                      fill='white'
                    />
                    <defs>
                      <linearGradient
                        id='paint0_linear_24831_23527'
                        x1='1.9325'
                        y1='7.18531'
                        x2='26.7938'
                        y2='21.541'
                        gradientUnits='userSpaceOnUse'>
                        <stop stopColor='#646464' />
                        <stop offset='0.72' stopColor='#1D1D1D' />
                        <stop offset='1' />
                      </linearGradient>
                    </defs>
                  </svg>
                </a>
              </Flexed>
              <img
                src={inviteLinksUnderlay}
                alt='invite links'
                style={{
                  width: '100%',
                  position: 'absolute',
                  left: 0,
                  bottom: 0,
                  right: 0
                }}
              />
              <InviteLinksUnderlay></InviteLinksUnderlay>
            </Box>
          </Flexed>
          <Flexed gap='20px' rowSM>
            <Box
              width='50%'
              widthSM='100%'
              relative
              overflow='hidden'
              m='0'
              style={{ marginBottom: 0 }}>
              <TopPerformerOverlay>
                <H3
                  center
                  color={color.colors.primary900}
                  style={{ fontSize: '35px', lineHeight: '50px' }}>
                  Unlocking <br /> Soon
                </H3>
              </TopPerformerOverlay>
              <H3 mb='15' color={color.colors.primary900}>
                Team Recruits
              </H3>
              <TopPerformer user={user} />
              <TopPerformer user={user} />
              <TopPerformer user={user} />
              <TopPerformer user={user} />
            </Box>
            <Box relative width='50%' widthSM='100%' overflow='hidden' m='0'>
              <H3 mb='15' color={color.colors.primary900}>
                Calendar
              </H3>
              <Calendar />
            </Box>
          </Flexed>
        </Flexed>
      </Flexed>

      <Modal
        isOpen={termsConditionsModal}
        // onRequestClose={() => setTermsConditionsModal(true)}
        contentLabel='Terms Conditions'
        className={'termsModalDashboard'}
        overlayClassName='myoverlay2'
        closeTimeoutMS={500}
        ariaHideApp={false}>
        <MigrationTermsPrivacy
          setTermsConditionsModal={setTermsConditionsModal}
          isMavieMigrationModalChecked={userInfo?.isMavieMigrationModalChecked}
        />
      </Modal>
    </AnimatedDashboard>
  );
};

export default Dashboard;

const TopPerformer = ({ user, title }: { user: User; title?: string }) => {
  return (
    <Box border mb='8'>
      {title && (
        <>
          <H5 color={color.colors.primary900}>{title}</H5>
          <SectionSeparator margin='10px 0' />
        </>
      )}
      <Flexed gap='1s0px' center>
        <UserImageCircle
          image={user?.profileImageUrl}
          name={user?.name}
          surname={user?.surname}
          size='40px'
          fontSize='16px'
          margin={'0 8px 0 0'}
        />
        <Flexed center between width='100%'>
          <div>
            <H4>{user?.username}</H4>
            <P3>
              {user?.name} {user?.surname}
            </P3>
          </div>

          <Flexed center>
            <img src={mex} alt='mex' />
            <P2 ml='8'>23/08/2025</P2>
          </Flexed>
        </Flexed>
      </Flexed>
    </Box>
  );
};
